export default "__VITE_ASSET__ICV8QAnR__"